import axios from 'axios';

export default {
    login(data) {
        return axios
            .post(process.env.VUE_APP_API_BASE_URL + 'user/check', data)
            .then(response => response.data);
    },
    resetPassword(data) {
        return axios
            .post(process.env.VUE_APP_API_BASE_URL + 'user/resetPassword', data)
            .then(response => response.data);
    },
    forgotPassword(data) {
        return axios
            .post(process.env.VUE_APP_API_BASE_URL + 'user/forgotPassword', data)
            .then(response => response.data);
    },
    initialPassword(data) {
        return axios
            .post(process.env.VUE_APP_API_BASE_URL + 'user/initialPassword', data)
            .then(response => response.data);
    },
};